var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 0.5,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#6FCF97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15.1665L38.0865 17.2968C38.6197 17.4158 39 17.8883 39 18.4355V30.087C39 32.4273 37.8298 34.6137 35.8827 35.911L28.5 40.8332L21.1173 35.911C19.169 34.6125 18 32.4273 18 30.0882V18.4355C18 17.8883 18.3803 17.4158 18.9135 17.2968L28.5 15.1665ZM33.694 23.5922L27.919 29.366L24.6197 26.0667L22.97 27.7163L27.9202 32.6665L35.3448 25.2418L33.694 23.5922V23.5922Z",
    fill: "#6FCF97"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/Icon_shield.1d1d6f55186ee3a6dc516511b11ac8d9.svg";
export { ForwardRef as ReactComponent };